

















































































import { Component, Vue } from 'vue-property-decorator'
import VModal from '@/components/VModal.vue'
import VButton from '@/components/VButton.vue'
import VInput from '@/components/VInput.vue'
import { Action, Getter } from 'vuex-class'
import * as accountTypes from '@/store/account/types'
import * as types from '@/store/content/types'
import ValidatedForm from '@/utilities/validation/validatedform'
import FormField from '@/utilities/validation/formfield'
import passwordValidator from '@/utilities/validators/password'
import Course from '@/store/models/course'
import VDropdown from '@/components/VDropdown.vue'

@Component({ components: { VButton, VDropdown, VInput, VModal } })
export default class Register extends Vue {
  @Getter('userInfo', { namespace: 'account' }) userInfo!: accountTypes.AccountState
  @Action('register', { namespace: 'account' }) register!: accountTypes.RegisterAction
  @Getter('gradesTree', { namespace: 'content' }) gradesTree!: types.GradesTree

  private selectedGrade = { grade: '', year: -1 }
  private registering = false
  private checkedCourses: Course[] = []
  private checkedBooks: { course: number; book: number }[] = []
  private showModal1 = true
  private modalStep = 1
  private ua = (this as any).$ua

  private password = new FormField(passwordValidator, '');
  private passwordForm = new ValidatedForm({
    password: this.password,
    repeatPassword: new FormField((value) => value === this.password.value ? [] : ['Wachtwoorden komen niet overeen'], '')
  })

  private submitRegister () {
    if (this.passwordForm.validateForm()) {
      this.registering = true
      this.register({
        username: this.$route.params.email,
        email: this.$route.params.email,
        password1: this.passwordForm.fields.password.value,
        password2: this.passwordForm.fields.repeatPassword.value,
        name: this.$route.params.name,
        courses: this.checkedCourses.map((course) => course.id),
        grade: this.selectedGrade.grade,
        year: this.selectedGrade.year,
        books: this.checkedBooks
      }).then(() => {
        this.modalStep = 5
        this.ua.trackEvent('account', 'register-success', this.$route.params.email)
      }).catch(() => {
        this.ua.trackEvent('account', 'register-failed', this.$route.params.email)
      }).finally(() => {
        this.registering = false
      })
    }
  }
}
